/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {DLSTheme} from '../../types/types';

// defines the attributes cell prop definitions ...
export interface AttributesCellProps {
  data?: {
    attributes: string[];
  }
}

// defines the styles used by the attributes and values cells ...
export const useStyles = makeStyles((theme: DLSTheme) => ({
  attributes : {
    margin        : 0,
    padding       : '10px 0',
    width         : '100%',
    listStyleType : 'none'
  },
  attribute : {
    height     : 'auto',
    lineHeight : '25px',
    width      : '100%'
  },
  cell : {
    overflow     : 'hidden',
    textOverflow : 'ellipsis',
    display      : 'block',
    width        : '100%',
    margin       : 'auto'
  }
}));

/**
 * @AttributesCellRenderer
 *
 * Defines the AttributesCellRenderer component. This component is used to display the
 * list of Audit Record attributes within the Audit Grid.
 */
export const AttributesCellRenderer = ({data}: AttributesCellProps) => {
  const classes = useStyles();
  const attributes: string[] = data?.attributes || null;

  return (
    attributes?.length > 0 ? (
      <ul className={classes.attributes}>
        {attributes.map((attribute: string, index) => {
          return (
            <li key={index} className={classes.attribute}>
              <span className={classes.cell}>{attribute}</span>
            </li>
          );
        })}
      </ul>
    ) : null
  );
};

export const ValuesRenderer = ({data}: any) => {
  const classes = useStyles();
  return (
    data?.values?.length > 0 ? (
      <ul className={classes.attributes}>
        {data.values.map((value: string, index) => {
          return (
            <li key={index} className={classes.attribute}>
              <span className={classes.cell}>{value}</span>
            </li>
          );
        })}
      </ul>
    ) : null
  );
};

const CTCValuesRenderer = ({values}: any) => {
  const {attributes, attribute, cell} = useStyles();
  return (
    values?.length > 0 ? (
      <ul className={attributes}>
        {values.map((value: string, i) => (
          <li key={`${value}-${i}`} className={attribute}>
            <span className={cell}>{value}</span>
          </li>
        ))}
      </ul>
    ) : null
  );
};
export const CTCOldValuesRenderer = ({data}: any) => (<CTCValuesRenderer values={data?.oldValues} />);
export const CTCNewValuesRenderer = ({data}: any) => (<CTCValuesRenderer values={data?.newValues} />);

export default AttributesCellRenderer;
